import {useTranslation} from "react-i18next";
import {useEffect, useMemo, useState} from "react";
import {API, Endpoints} from "@brg/api";
import {IDiscipline} from "../../../constants/courses/IDiscipline";

interface IResp {
    disciplines: IDiscipline<'Local'>[]
    options: {value: string, label: string}[]
    colors: {[key: string]: string}
    isLoading: boolean
    error: boolean
}

export const useGetDisciplinesList = (teamId?: string): IResp => {
    const [resp, setResp] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const { i18n } = useTranslation();
    const [respUntranslated, setRespUntranslated] = useState<any>([]);

    useEffect(() => {

        if (!teamId) return
        setIsLoading(true)

        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetDisciplines')
            .get()
            .addQuery('teamId', teamId || '')
            .send()
            .then((r) => r ? r.json() : undefined)
            .then((r) => {
                setIsLoading(false)
                setRespUntranslated(r)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [teamId])

    useEffect(() => {
        setResp(API.toLang(respUntranslated, i18n.language) as any)
    }, [respUntranslated, i18n])

    const options = useMemo(() => {
        return (resp?.length > 0 ? resp : [{id: "", name: ""}]).map((i: any) => ({ value: i?.id, label: i?.name }))
    }, [resp]);

    const colors = useMemo(() => {
        const result = {};
        (resp || []).forEach((i: any) => {
            // @ts-ignore
            result[i?.id] = i?.color
        })
        return result;
    }, [resp]);

    return {disciplines: resp, options, colors, isLoading, error};
}import {useTranslation} from "react-i18next";
import {useEffect, useMemo, useState} from "react";
import {API, Endpoints} from "@brg/api";
import {IDiscipline} from "../../../constants/courses/IDiscipline";

interface IResp {
    disciplines: IDiscipline<'Local'>[]
    options: {value: string, label: string}[]
    colors: {[key: string]: string}
    isLoading: boolean
    error: boolean
}

export const useGetDisciplinesList = (teamId?: string): IResp => {
    const [resp, setResp] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const { i18n } = useTranslation();
    const [respUntranslated, setRespUntranslated] = useState<any>([]);

    useEffect(() => {

        if (!teamId) return
        setIsLoading(true)

        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetDisciplines')
            .get()
            .addQuery('teamId', teamId || '')
            .send()
            .then((r) => r ? r.json() : undefined)
            .then((r) => {
                setIsLoading(false)
                setRespUntranslated(r)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [teamId])

    useEffect(() => {
        setResp(API.toLang(respUntranslated, i18n.language) as any)
    }, [respUntranslated, i18n])

    const options = useMemo(() => {
        return (resp?.length > 0 ? resp : [{id: "", name: ""}]).map((i: any) => ({ value: i?.id, label: i?.name }))
    }, [resp]);

    const colors = useMemo(() => {
        const result = {};
        (resp || []).forEach((i: any) => {
            // @ts-ignore
            result[i?.id] = i?.color
        })
        return result;
    }, [resp]);

    return {disciplines: resp, options, colors, isLoading, error};
}